import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import ObtainIosReceiptTokensForm from "./obtain-receipt-token-form";
import ObtainIosReceiptTokensData from "./obtain-receipt-token-data";

const ObtainIosReceiptTokens = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "QA_OBTAIN_IOS_RECEIPT_TOKENS",
      "QA_OBTAIN_IOS_RECEIPT_TOKENS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("QA")}
        subTitle={i18n.get("OBTAIN_IOS_RECEIPT_TOKENS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <ObtainIosReceiptTokensForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ObtainIosReceiptTokensData />
    </ET3PageDiv>
  );
});

export default ObtainIosReceiptTokens;
